/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { readContract, waitForTransaction, writeContract } from '@wagmi/core'
import '../App.css'
import '../styles/MainContainer.css'
import logo from '../icons/logo.png'
import TopBar from '../components/TopBar'
import { useAccount, useChainId } from 'wagmi'
import RatioContractAbi from '../config/RatioContractAbi.json'
import { ratioContract, rhaaAddress, whitelists, wtnAddress } from '../utils/constants.ts'
import toast from 'react-hot-toast'
import { config } from '../config.jsx'

const App = () => {
  const { address, isConnected, chain } = useAccount()
  const chainId = useChainId()
  const [pending, setPending] = useState(false)
  const [editOption, setEditOption] = useState(0)
  const [activeOption, setActiveOption] = useState(0)
  const [tokenRate, setTokenRate] = useState(0)
  const [editRate, setEditRate] = useState(1)
  const [baseRate, setBaseRate] = useState(1)
  const [quoteRate, setQuoteRate] = useState(1)

  const onEditOptionChange = (event) => {
    setEditOption(event.target.value)
  }
  const onActiveOptionChange = (event) => {
    setActiveOption(event.target.value)
  }
  const onEditRateChange = (event) => {
    setEditRate(event.target.value)
  }
  const onBaseRateChange = (event) => {
    setBaseRate(event.target.value)
  }
  const onQuoteRateChange = (event) => {
    setQuoteRate(event.target.value)
  }

  const [isEnter, setIsEnter] = useState(false)
  const enterClickHandler = async () => {
    if (isWhitelist) {
      setIsEnter(true)
    }
  }
  

  const [isWhitelist, setIsWhitelist] = useState(false)
  useEffect(() => {
    if (whitelists.includes(address) && chain) {
      setIsWhitelist(true)
    } else {
      setIsWhitelist(false)
    }
  }, [address])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const _editRate = await readContract(config, {
          address: ratioContract,
          abi: RatioContractAbi,
          functionName: 'getExchangeRate',
          args: [wtnAddress, editOption],
          chainId: chainId
        })
        setEditRate(Math.floor(_editRate / 1000000))
        setTokenRate(Math.floor(_editRate / 1000000))
      } catch (e) {
        toast.error('Error fetching data')
        setEditRate(0)
      }

    }
    fetchData()
  }, [editOption])

  const editRateHandler = async () => {
    if (pending) {
      toast.error('Please wait for the previous transaction to complete')
      return;
    }
    if (tokenRate == editRate) {
      toast.error('Please enter a different rate')
      return;
    }
    const updateRate = await writeContract(config, {
      address: ratioContract,
      abi: RatioContractAbi,
      functionName: 'updateRates',
      args: [[wtnAddress], [editRate * 1000000], editOption],
      chainId: Number(chainId),
      gasLimit: 150_000_000n
    })
    setPending(true)
    await waitForTransaction(config, {
      hash: updateRate
    })
    setPending(false)
    toast.success('Rate updated successfully')
  }


  const addRateHandler = async () => {
    if (pending) {
      toast.error('Please wait for the previous transaction to complete')
      return;
    }
    const updateRate = await writeContract(config, {
      address: ratioContract,
      abi: RatioContractAbi,
      functionName: 'updateRates',
      args: [[rhaaAddress, wtnAddress], [baseRate * 1000000, quoteRate * 1000000], activeOption],
      chainId: Number(chainId),
      gasLimit: 150_000_000n
    })
    setPending(true)
    await waitForTransaction(config, {
      hash: updateRate
    })
    setPending(false)
    toast.success('Rate added successfully')
  }
  const removeRateHandler = async () => {
    if (pending) {
      toast.error('Please wait for the previous transaction to complete')
      return;
    }
    const updateRate = await writeContract(config, {
      address: ratioContract,
      abi: RatioContractAbi,
      functionName: 'updateRates',
      args: [[rhaaAddress, wtnAddress], [0, 0], activeOption],
      chainId: Number(chainId),
      gasLimit: 150_000_000n
    })
    setPending(true)
    await waitForTransaction(config, {
      hash: updateRate
    })
    setPending(false)
    toast.success('Rate removed successfully')
  }

  return (
    <div>
      <div className="GlobalContainer launches-all-padding">
        <div>
          <TopBar />
          <div className="max-w-7xl m-auto pt-36 pb-24 px-4 sm:px-12 sm:py-10">
            {isWhitelist && (
              <div
                className="flex w-full items-center justify-center flex-col mt-8"
                style={{ display: isEnter ? 'none' : '' }}
              >
                <img src={logo} className="w-[250px] sm:w-[350px]" alt="logo" />
                <button
                  className="rounded-full text-2xl text-white mt-8 button-background px-8 py-2 min-w-[300px] border-button"
                  onClick={enterClickHandler}
                >
                  Enter
                </button>
              </div>
            )}
            {isEnter && (
              <div className="grid md:grid-cols-2 gap-12 mt-8">
                <div className="flex items-center justify-center">
                  <div className="card-border-background">
                    <div className="rounded-[25px] lg:px-8 px-2.5 py-5 card-background">
                      <div className="w-full text-xs sm:text-sm">
                        <div className="w-full">
                          <p className="text-xl text-center">
                            Edit Token Ratios
                          </p>
                        </div>
                        <div className="w-full flex justify-between mt-4 gpa-4 items-center flex-row-reverse ">
                          <p className="text-xl">Select ratio option</p>
                          <div className="w-[150px] ml-4">
                            <select
                              id="ratioOptions"
                              onChange={onEditOptionChange}
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            >
                              <option value="0" key={'0'}>Option 1</option>
                              <option value="1" key={'1'}>Option 2</option>
                              <option value="2" key={'2'}>Option 3</option>
                              <option value="3" key={'3'}>Option 4</option>
                              <option value="4" key={'4'}>Option 5</option>
                            </select>
                          </div>
                        </div>
                        <div className="flex w-full justify-around text-center items-center mt-4">
                          <div>
                            <p className="text-xl">WTN</p>
                            <p className="text-2xl">1</p>
                          </div>
                          <div>
                            <p>:</p>
                          </div>
                          <div>
                            <p className="text-xl">RHAA</p>
                            <input
                              className="w-[120px] rounded-full text-center text-xl"
                              value={editRate}
                              onChange={onEditRateChange}
                            />
                          </div>
                        </div>
                        <div className="flex mt-4 justify-between">
                          <div>
                            <p className="text-xl">Change</p>
                          </div>
                          <p className="text-xl">{editRate == 0 ? 0 : new Intl.NumberFormat().format(1/editRate * 100)}%</p>
                        </div>
                        <button className="button-background py-3 mt-4 w-full rounded-full " onClick={editRateHandler}>
                          SET
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div className="card-border-background">
                    <div className="rounded-[25px] lg:px-8 px-2.5 py-5 card-background">
                      <div className="w-full text-xs sm:text-sm">
                        <div className="w-full">
                          <p className="text-xl text-center">
                            Active Ratio Tokens
                          </p>
                        </div>
                        <div className="w-full flex justify-between mt-4 gpa-4 items-center flex-row-reverse ">
                          <p className="text-xl">Select ratio option</p>
                          <div className="w-[150px] ml-4">
                            <select
                              id="ratioActiveOptions"
                              onChange={onActiveOptionChange}
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            >
                              <option value="0" key={'0'}>Option 1</option>
                              <option value="1" key={'1'}>Option 2</option>
                              <option value="2" key={'2'}>Option 3</option>
                              <option value="3" key={'3'}>Option 4</option>
                              <option value="4" key={'4'}>Option 5</option>
                            </select>
                          </div>
                        </div>
                        <div className="flex w-full justify-around text-center items-center mt-4">
                          <div>
                            <p className="text-xl">WTN</p>
                            <input
                              className="w-[120px] rounded-full text-center text-xl"
                              value={baseRate}
                              onChange={onBaseRateChange}
                            />
                          </div>
                          <div>
                            <p>:</p>
                          </div>
                          <div>
                            <p className="text-xl">RHAA</p>
                            <input
                              className="w-[120px] rounded-full text-center text-xl"
                              value={quoteRate}
                              onChange={onQuoteRateChange}
                            />
                          </div>
                        </div>
                        <div className="flex w-full gap-2 mt-12">
                          <button className="button-background py-3 mt-4 w-full rounded-full" onClick={addRateHandler}>
                            ADD
                          </button>
                          <button className="button-background py-3 mt-4 w-full rounded-full" onClick={removeRateHandler}>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
